import { render, staticRenderFns } from "./kefu2.vue?vue&type=template&id=55de810f&scoped=true"
import script from "./kefu2.vue?vue&type=script&lang=js"
export * from "./kefu2.vue?vue&type=script&lang=js"
import style0 from "./kefu2.vue?vue&type=style&index=0&id=55de810f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de810f",
  null
  
)

export default component.exports